export const CACHE_KEYS = {
  PROPERTIES_TYPES_PARENTS: realEstateId => `properties:${realEstateId}:types:parents`,
  PROPERTIES_TYPES_CHILDREN: realEstateId => `properties:${realEstateId}:types:children`,
  PROPERTIES_FORM_OPTIONS: realEstateId => `properties:${realEstateId}:form-options`,
  AMENITIES_GROUPS: realEstateId => `amenities:${realEstateId}:groups`,
  AMENITIES_OPTIONS: realEstateId => `amenities:${realEstateId}:options`,
  ENTERPRISES_TYPES: realEstateId => `enterprises:${realEstateId}:types`,
  ENTERPRISES_STATUS: realEstateId => `enterprises:${realEstateId}:status`,
  EXTERNAL_PORTALS: 'external:portals',
}

export const CACHE_PREFIXES = {
  PROPERTIES: 'properties:',
  AMENITIES: 'amenities:',
  ENTERPRISES: 'enterprises:',
  EXTERNAL: 'external:',
}

export const STORAGE_KEYS = {
  OPERATOR: 'operator',
  TOKEN: 'tk',
  SA_TOKEN: 'satk',
  SUBSCRIPTION_PLAN: 'subscription_plan',
  WARNINGS: 'warnings',
  PORTAL_ACCESS: 'Administrativo_is_portal',
  SLUG: 'Administrativo_slug',
  OPERATOR_RAW: 'Administrativo_operator',
  PANEL_HISTORY: 'panelListHistory',
  SELECTED_CODES: 'selected_codes',
  LAST_PATH: 'last_path',
  THEME_CONFIG_TAB: 'ui:tabs:editar-tema',
}
